import React, { Component, Fragment } from 'react';
import { translate } from 'react-i18next';
import { NavLink } from 'react-router-dom';
import { url, request } from '../../../../config';
import { Autocomplete, TextField } from '@mui/material';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import transferConfirmation from './../../img/transfer-confirmation.svg';
import { statusCodes } from '../../../../helpers/statusCodes';

class Order extends Component {
    state = {
        open: false,
        fullName: "",
        mail: "",
        message: "",
        phoneNumber: "",
        submit: false,
        data: null,
        step: 1
    }

    getData = () => {
        this.props.updateAppState('isLoadingTransparentBackground', true);
        let getDataRequestBody = {
            token: localStorage.getItem('token'),
            lang: localStorage.getItem('i18nextLng').toUpperCase()
        }
        fetch(request("posTerminal/getData", getDataRequestBody))
            .then(res => res.text())
            .then((getDataResponseJSON) => {
                const JSON = require('true-json-bigint');
                let getDataResponse = JSON.parse(getDataResponseJSON);
                if (getDataResponse.status.statusCode !== 1) {
                    if (getDataResponse.status.statusCode === 200) {
                        this.props.logout();
                    } else {
                        this.props.alertState(true, 'error', this.props.t('an error occurred'), this.props.t(getDataResponse.status.statusCode));
                        this.props.updateAppState('isLoadingTransparentBackground', false);
                    }
                }
                else {
                    this.setState({ payload: getDataResponse })
                    this.props.updateAppState('isLoadingTransparentBackground', false);
                }
            },
                (error) => {
                    this.props.history.push("/technical-break");
                });
    }

    getPhnCategoryAndReqType = () => {
        this.props.updateAppState('isLoadingTransparentBackground', true);
        fetch(url("suggestion/suggestions/getPhnCategoryAndReqType", null, "GET"))
            .then(res => res.text())
            .then((getPhnCategoryAndReqTypeResponseJSON) => {
                const JSON = require('true-json-bigint');
                let getPhnCategoryAndReqTypeResponse = JSON.parse(getPhnCategoryAndReqTypeResponseJSON);
                if (getPhnCategoryAndReqTypeResponse.status.statusCode !== 1) {
                    if (getPhnCategoryAndReqTypeResponse.status.statusCode === 200) {
                        this.props.logout();
                    } else {
                        getPhnCategoryAndReqTypeResponse.status.statusCode === statusCodes.ACCESS_DENIED_OPERATION ?
                            this.props.alertState(true, "warning", this.props.t("Information"), this.props.t(getPhnCategoryAndReqTypeResponse.status.statusCode), null, true)
                            :
                            this.props.alertState(true, 'error', this.props.t('an error occurred'), this.props.t(getPhnCategoryAndReqTypeResponse.status.statusCode));
                        this.props.updateAppState('isLoadingTransparentBackground', false);
                    }
                }
                else {
                    this.setState({ payload: getPhnCategoryAndReqTypeResponse.model });
                    this.props.updateAppState('isLoadingTransparentBackground', false);
                }
            },
                (error) => {
                    this.props.history.push("/technical-break");
                });
    }

    getPhoneNumber = (number) => {
        ['-', '(', ')', ' '].forEach(char => {
            while (number.indexOf(char) !== -1) {
                number = number.slice(0, number.indexOf(char)) + number.slice(number.indexOf(char) + 1, number.length);
            }
        });
        return number;
    }

    check = (e) => {
        e.preventDefault();
        this.setState({ submit: true });
        let { branchId, tariffId, sferadeyId, sferadeyDetail, facilityName, facilityAccountCode, facilityCityId, facilityAddress } = this.state;
        const isFormValid = [branchId, tariffId, sferadeyId, sferadeyDetail, facilityName, facilityAccountCode, facilityCityId, facilityAddress].every(Boolean);
        if (isFormValid) {
            this.setState({ step: 2 })
        }
    }

    create = (e) => {
        e.preventDefault();
        let { branchId, tariffId, sferadeyId, sferadeyDetail, facilityName, facilityAccountCode, facilityCityId, facilityAddress } = this.state;
        this.props.updateAppState('isLoadingTransparentBackground', true);
        let createRequestBody = {
            branchId, tariffId, sferadeyId, sferadeyDetail, facilityName, facilityAccountCode, facilityCityId, facilityAddress,
            token: localStorage.getItem('token'),
            lang: localStorage.getItem('i18nextLng').toUpperCase(),
        }
        fetch(request("posTerminal/create", createRequestBody, "POST"))
            .then(res => res.text())
            .then((createResponseJSON) => {
                const JSON = require('true-json-bigint');
                let createResponse = JSON.parse(createResponseJSON);
                if (createResponse.status.statusCode !== 1) {
                    if (createResponse.status.statusCode === 200) {
                        this.props.logout();
                    } else {
                        this.props.alertState(true, 'error', this.props.t('an error occurred'), this.props.t(createResponse.status.statusCode));
                        this.props.updateAppState('isLoadingTransparentBackground', false);
                    }
                }
                else {
                    this.props.alertState(true, 'success', this.props.t('successful operation'), this.props.t('Your POS Terminal order request has been forwarded to the bank'), null, null, () => this.props.history.push('/dashboard/orders/pos/list'));
                    this.props.updateAppState('isLoadingTransparentBackground', false);
                }
            },
                (error) => {
                    this.props.history.push("/technical-break");
                });
    }

    componentDidMount() {
        this.getData();
    }

    render() {
        let { t } = this.props;
        let { payload, submit, facilityName, facilityAccountCode, tariffId, facilityCityId, facilityAddress, sferadeyId, sferadeyDetail, branchId, step } = this.state;
        return (
            <Fragment>
                <div className="dashboard-header-route">
                    <div className="dashboard-header-route-left">
                        <button onClick={() => this.props.history.goBack()}>
                            <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M11.7344 21.2188L12.6719 20.3281C12.9062 20.0938 12.9062 19.7188 12.6719 19.5312L5.40625 12.2188H21.4375C21.7188 12.2188 22 11.9844 22 11.6562V10.3438C22 10.0625 21.7188 9.78125 21.4375 9.78125H5.40625L12.6719 2.51562C12.9062 2.32812 12.9062 1.95312 12.6719 1.71875L11.7344 0.828125C11.5469 0.59375 11.1719 0.59375 10.9375 0.828125L1.14062 10.625C0.90625 10.8594 0.90625 11.1875 1.14062 11.4219L10.9375 21.2188C11.1719 21.4531 11.5469 21.4531 11.7344 21.2188Z" fill="#2E3131" />
                            </svg>
                        </button>
                        <h2>{t('Apply')}</h2>
                    </div>
                </div>
                <div className="dashboard-payment-container">
                    <div className="dashboard-payment-container-data-section">
                        <div className="dashboard-transfer-list-header">
                            <div className="dashboard-transfer-list-header-container dashboard-transfer-list-header-container__left">
                                {/* <NavLink exact to="/dashboard/orders/credit" className="dashboard-transfer-list-header-link" activeClassName="dashboard-transfer-list-header-container dashboard-transfer-list-header-link__active">{t("credit")}</NavLink> */}
                                <NavLink exact to="/dashboard/orders/plastic-card" className="dashboard-transfer-list-header-link" activeClassName="dashboard-transfer-list-header-container dashboard-transfer-list-header-link__active">{t("Plastic card")}</NavLink>
                                {localStorage.getItem('checkResident') === "1" && localStorage.getItem("isAsan") === "true" &&
                                    <NavLink exact to="/dashboard/orders/account" className="dashboard-transfer-list-header-link" activeClassName="dashboard-transfer-list-header-container dashboard-transfer-list-header-link__active">{t("Account")}</NavLink>}
                                {localStorage.getItem('compId') &&
                                    <NavLink to="/dashboard/orders/pos" className="dashboard-transfer-list-header-link" activeClassName="dashboard-transfer-list-header-container dashboard-transfer-list-header-link__active">{t("POS Terminal Order")}</NavLink>}
                            </div>
                        </div>
                        <div className="dashboard-contact-section py-4">
                            {payload &&
                                <form onSubmit={(e) => step === 2 ? this.create(e) : this.check(e)} className="dashboard-account-container-component dashboard-contact-section-form align-items-end" style={{ maxWidth: '732px' }}>
                                    <TextField disabled={step === 2} variant="outlined" sx={{ width: 350 }} error={!payload.userInfo.custId && submit} label={t('Customer Code')} value={payload.userInfo.custId} InputProps={{ readOnly: true }} />
                                    <TextField disabled={step === 2} variant="outlined" sx={{ width: 350 }} error={!payload.userInfo.name && !payload.userInfo.surname && submit} label={t('Customer Name')} value={[payload.userInfo.name, payload.userInfo.surname].filter(Boolean).join(' ')} InputProps={{ readOnly: true }} />
                                    <TextField disabled={step === 2} variant="outlined" sx={{ width: 350 }} error={!facilityName && submit} label={t('Object Name')} value={facilityName} onChange={(e) => this.setState({ facilityName: e.target.value })}
                                        InputProps={{ endAdornment: <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M11.3333 2C11.5083 1.8249 11.7162 1.68601 11.945 1.59125C12.1738 1.49649 12.419 1.44772 12.6666 1.44772C12.9142 1.44772 13.1594 1.49649 13.3882 1.59125C13.617 1.68601 13.8248 1.8249 13.9999 2C14.175 2.1751 14.3139 2.38297 14.4087 2.61174C14.5034 2.84051 14.5522 3.08571 14.5522 3.33333C14.5522 3.58096 14.5034 3.82615 14.4087 4.05493C14.3139 4.2837 14.175 4.49157 13.9999 4.66667L4.99992 13.6667L1.33325 14.6667L2.33325 11L11.3333 2Z" stroke="#1E1E1E" stroke-linecap="round" stroke-linejoin="round" /></svg> }} />
                                    <TextField disabled={step === 2} variant="outlined" sx={{ width: 350 }} error={!facilityAccountCode && submit} label={t('Object Registration Code')} value={facilityAccountCode} onChange={(e) => this.setState({ facilityAccountCode: e.target.value })}
                                        InputProps={{ endAdornment: <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M11.3333 2C11.5083 1.8249 11.7162 1.68601 11.945 1.59125C12.1738 1.49649 12.419 1.44772 12.6666 1.44772C12.9142 1.44772 13.1594 1.49649 13.3882 1.59125C13.617 1.68601 13.8248 1.8249 13.9999 2C14.175 2.1751 14.3139 2.38297 14.4087 2.61174C14.5034 2.84051 14.5522 3.08571 14.5522 3.33333C14.5522 3.58096 14.5034 3.82615 14.4087 4.05493C14.3139 4.2837 14.175 4.49157 13.9999 4.66667L4.99992 13.6667L1.33325 14.6667L2.33325 11L11.3333 2Z" stroke="#1E1E1E" stroke-linecap="round" stroke-linejoin="round" /></svg> }} />
                                    <Autocomplete
                                        disabled={step === 2}
                                        sx={{ width: 350 }}
                                        options={payload?.tariffs}
                                        getOptionLabel={option => option.name}
                                        onChange={(event, newValue) => { this.setState({ tariffId: newValue?.id }); !newValue && this.setState({ branchId: null }); }}
                                        renderOption={(props, option) => {
                                            const { key, ...optionProps } = props;
                                            return (
                                                <li key={key} {...optionProps}>
                                                    <OverlayTrigger overlay={(props) => (
                                                        <Tooltip className='ml-3' {...props}>
                                                            {option.description}
                                                        </Tooltip>
                                                    )} placement="right">
                                                        <p className='m-0 w-100'>{option.name}</p>
                                                    </OverlayTrigger>
                                                </li>);
                                        }}
                                        renderInput={(params) => <TextField
                                            {...params}
                                            error={!tariffId && submit}
                                            placeholder={t('Choose')}
                                            label={t('Tariff Package')}
                                            disabled={step === 2}
                                        />} />
                                    <Autocomplete
                                        disabled={step === 2}
                                        sx={{ width: 350 }}
                                        options={payload?.cities}
                                        getOptionLabel={option => option.name}
                                        onChange={(event, newValue) => { this.setState({ facilityCityId: newValue?.id }) }}
                                        renderInput={(params) => <TextField
                                            {...params}
                                            error={!facilityCityId && submit}
                                            placeholder={t('Choose')}
                                            label={t('City/District of the object')}
                                        />} />
                                    <TextField disabled={step === 2} variant="outlined" sx={{ width: 732 }} error={!facilityAddress && submit} label={t('Object address')} value={facilityAddress} onChange={(e) => this.setState({ facilityAddress: e.target.value })}
                                        InputProps={{ endAdornment: <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M11.3333 2C11.5083 1.8249 11.7162 1.68601 11.945 1.59125C12.1738 1.49649 12.419 1.44772 12.6666 1.44772C12.9142 1.44772 13.1594 1.49649 13.3882 1.59125C13.617 1.68601 13.8248 1.8249 13.9999 2C14.175 2.1751 14.3139 2.38297 14.4087 2.61174C14.5034 2.84051 14.5522 3.08571 14.5522 3.33333C14.5522 3.58096 14.5034 3.82615 14.4087 4.05493C14.3139 4.2837 14.175 4.49157 13.9999 4.66667L4.99992 13.6667L1.33325 14.6667L2.33325 11L11.3333 2Z" stroke="#1E1E1E" stroke-linecap="round" stroke-linejoin="round" /></svg> }} />
                                    <Autocomplete
                                        disabled={step === 2}
                                        sx={{ width: 350 }}
                                        options={payload?.sferadeys}
                                        getOptionLabel={option => option.name}
                                        onChange={(event, newValue) => { this.setState({ sferadeyId: newValue?.id }); !newValue && this.setState({ sferadeyDetail: '' }) }}
                                        renderInput={(params) => <TextField
                                            {...params}
                                            error={!sferadeyId && submit}
                                            placeholder={t('Choose')}
                                            label={t('Field of activity')}
                                        />} />
                                    {sferadeyId && <TextField disabled={step === 2} variant="outlined" sx={{ width: 350 }} error={!sferadeyDetail && submit} label={t('detailed')} value={sferadeyDetail} onChange={(e) => this.setState({ sferadeyDetail: e.target.value })}
                                        InputProps={{ endAdornment: <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M11.3333 2C11.5083 1.8249 11.7162 1.68601 11.945 1.59125C12.1738 1.49649 12.419 1.44772 12.6666 1.44772C12.9142 1.44772 13.1594 1.49649 13.3882 1.59125C13.617 1.68601 13.8248 1.8249 13.9999 2C14.175 2.1751 14.3139 2.38297 14.4087 2.61174C14.5034 2.84051 14.5522 3.08571 14.5522 3.33333C14.5522 3.58096 14.5034 3.82615 14.4087 4.05493C14.3139 4.2837 14.175 4.49157 13.9999 4.66667L4.99992 13.6667L1.33325 14.6667L2.33325 11L11.3333 2Z" stroke="#1E1E1E" stroke-linecap="round" stroke-linejoin="round" /></svg> }} />
                                    }
                                    <Autocomplete
                                        disabled={step === 2}
                                        sx={{ width: 350 }}
                                        options={tariffId ? payload?.customBranches : payload?.allBranches}
                                        getOptionLabel={option => option.name}
                                        value={tariffId ? (payload?.customBranches?.find(item => item.id == branchId) || null) : (payload?.allBranches?.find(item => item.id == branchId) || null)}
                                        onChange={(event, newValue) => { this.setState({ branchId: newValue?.id }) }}
                                        renderInput={(params) => <TextField
                                            {...params}
                                            error={!branchId && submit}
                                            placeholder={t('Choose')}
                                            label={t('branch')}
                                        />} />
                                    <div className="dashboard-payment-container-data-section-content-container-form-footer d-flex justify-content-end">
                                        {step === 2 && <button type='button' onClick={() => this.setState({ step: 1 })} className="dashboard-contact-section-button mr-2">{t('Update')}</button>}
                                        <button type='submit' className="dashboard-contact-section-button">{step === 2 ? t('Order') : t('save')}</button>
                                    </div>
                                </form>}
                        </div>
                    </div>
                    <div className="dashboard-payment-container-confirmation-section">
                        <div className="dashboard-payment-container-confirmation-section-header">
                            <h3 className="dashboard-payment-container-confirmation-section-header-title">{t('What happens after you place your order')}</h3>
                        </div>
                        <div className="dashboard-payment-container-confirmation-section-content">
                            <img src={transferConfirmation} alt="img" className="dashboard-payment-container-confirmation-section-content-image" />
                            <div className="dashboard-payment-container-confirmation-section-content-description">
                                <p>{t('order content')}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>
        )
    }
}
export default translate("translation")(Order);